<template>
    <div class="flex items-center">
        <IconTutorialArrow/>
        <div class="ml-16 flex grow flex-col items-center gap-2">
            <component :is="components.get(compName)"/>

            <p class="mt-6 text-sm text-grey-90">
                {{ $t('tutorialOne') }}
            </p>
            <p class="text-sm text-grey-90">
                {{ $t('tutorialTwo') }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import IconTutorialArrow from '@/components/icons/IconTutorialArrow.vue'
import { defineAsyncComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();

// 需要加载的组件集合
const components = ref(new Map<string, any>())
components.value.set(
    'IconResultTutorialCN',
    defineAsyncComponent(() => import('@/components/icons/IconResultTutorialCN.vue'))
)
components.value.set(
    'IconResultTutorialEN',
    defineAsyncComponent(() => import('@/components/icons/IconResultTutorialEN.vue'))
)
components.value.set(
    'IconResultTutorialJP',
    defineAsyncComponent(() => import('@/components/icons/IconResultTutorialJP.vue'))
)
const compName = ref(`IconResultTutorial${locale.value.toUpperCase() === 'TW' ? 'CN' : locale.value.toUpperCase()}`)
</script>
